import { useTranslation, FlowStepProps, GenericStepLayout } from '@helios/frontend-core';

export interface Props {
  onDismiss: () => void;
}

export function UtilityNotSupportedStep({ onDismiss, setStep, previousStep }: Props & FlowStepProps) {
  const { t } = useTranslation();
  const TRACKING_ID = `takeover-utility-not-supported-step`;

  return (
    <GenericStepLayout
      icon="drizzle"
      title={t('connectUtilityTakeover.steps.utility-not-supported.title')}
      description={t('connectUtilityTakeover.steps.utility-not-supported.description')}
      primaryCTA={{
        onClick: () => {
          setStep('choose-utility');
          onDismiss();
        },
        label: t('common.ok'),
      }}
      secondaryCTA={{
        onClick: () => {
          previousStep();
        },
        label: t('common.goBack'),
      }}
      trackingId={TRACKING_ID}
    />
  );
}

export default UtilityNotSupportedStep;
